/*
 * @Descripttion: 画布编辑页面
 * @Author: yang chenglin
 */
import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
  useReducer,
  createContext,
  Context,
} from 'react';
import { history } from 'ice';
import { event, store } from '@ice/stark-data';
import moment from 'moment';

import LzDialog from '@/components/common/LzDialog';
import styles from './index.module.scss';
import LzMsg from '@/components/common/LzMsg';
import Graph from '@/utils/Graph';
import { CanvasService, Servlets } from '@/service';

import ConfirmDialog from '@/components/Dialog/ConfirmDialog';
import Header from './components/Header';
import Menu from './components/Menu';
import Toolbar from './components/ToolBar';
import CrowdNumDialog from './components/CrowdNumDialog';
import CrowdEffectNumDialog from './components/CrowdEffectNumDialog';
import UUID from '@/utils/UUID';
import utils from '@/common/utils';

import { allNodes } from './Nodes';
import contextMenuNode from './Nodes'; // 鼠标右键事件所需node节点信息
import { Checkbox, Loading } from '@alifd/next';
import GuideDialog from './components/GuideDialog';

// import OperationDialog from '@/components/sms/OperationDialog';
// import PageUtils from '@/components/sms/OperationDialog/utils';

const prodValue =
  (store.get('SYS_PROD') ||
    sessionStorage.getItem('SYS_PROD') ||
    localStorage.getItem('SYS_PROD'));

const shopId = JSON.parse(localStorage.getItem('LZ_CURRENT_SHOP'))?.shopId;

let copyIndex = 1;

// 页面类型枚举
export enum PageType {
  editor = 'editor', // 流程编辑器
  preview = 'preview', // 预执行查看
  detail = 'detail', // 详情
}

// 保存对象枚举
export enum SaveTarget {
  process, // 保存流程
  template, // 保存模版
}
// 保存类型枚举
export enum SaveType {
  save, // 保存
  pre, // 预执行
  submit, // 提交
  stopPreview, // 停止预执行
}

interface Node {
  nodeId: string;
  components: any;
}

// 节点数据
let nodeData = [];
// 本页面组件中共享的context
export const ActivityContext: Context<any> = createContext({});

export default ({ match }) => {
  // const [showOperationDialog, setShowOperationDialog] = useState(false); // 是否展示运营活动弹窗
  const [showGuidesDialog, setShowGuidesDialog] = useState(false); // 是否展示引导页弹窗
  const [showNewTips, setShowNewTips] = useState(false); // 是否展示画布2.1新功能提示弹窗
  const [ isCheck, setCheck ] = useState(); //画布2.1通知弹窗是否选择了不再展示
  // 拖拽开始时，会先判断人群节点是否超出150的限制，提示弹窗flag
  const [crowdNodeNumDialog, setCrowdNodeNumDialog] = useState(false);
  // 拖拽开始时，会先判断人群分析节点是否超出10的限制，提示弹窗flag
  const [crowdEffectNodeNumDialog, setCrowdEffectNodeNumDialog] = useState(false);
  // 通过缓存信息判断是否展示，且只在编辑页才展示，查看详情不展示
  // 画布2.1弹窗不再展示
  const handleCheck = (v) => {
    setCheck(v);
    localStorage.setItem('isShowFncDialogCanvasThirdNodeTips', JSON.stringify(!v));
  }
  useEffect(() => {
    if (match.params.type === PageType.editor) {
      // setShowNewTips(true);
      let isShowFncDialog = JSON.parse(localStorage.getItem('cjyx-canvas-guide-dialog-2'));
      let isShowFncNodeTipsDialog = JSON.parse(localStorage.getItem('isShowFncDialogCanvasThirdNodeTips'));
      // 如果缓存里没有存当前商铺当前弹窗
      if (isShowFncDialog === null) {
        setShowGuidesDialog(true);
        localStorage.setItem('cjyx-canvas-guide-dialog-2', JSON.stringify([shopId]));
      } else if (!isShowFncDialog.includes(shopId)) {
        let originArr = [...isShowFncDialog];
        originArr.push(shopId);
        setShowGuidesDialog(true);
        localStorage.setItem('cjyx-canvas-guide-dialog-2', JSON.stringify(originArr));
      } else {
        // 无需操作
      }

      // if(isShowFncNodeTipsDialog !== null) { //存过localStorage
      //   setCheck(!isShowFncNodeTipsDialog);
      //   if(isShowFncNodeTipsDialog) { // 展示弹窗
      //     setShowNewTips(true);
      //   } else { // 不展示弹窗
      //     setShowNewTips(false);
      //   }
      // } else { // 没有存过localStorage
      //   setShowNewTips(true);
      // }
    }
  }, [])
  // 画布编辑权限，是否可以操作超过一定数量的节点
  const [powerInfo, setPower] = useState(false);

  // 页面信息
  const pageInfo = useMemo(
    () => ({
      type: match.params.type, // 页面的类型
      campaignId: match.params.campaignId, // 当前页面活动id
    }),
    [match.params.type]
  );

  // toolbar组件中，为短信富信组件统一设置的发送时间 依次为：短信、富信、人群包分析、人群包分析新开始、人群包分析新结束
  const [commonSendTime, setCommonSmsSendTime] = useState(['', '', '', '', '']);
  // 是否勾选了两种类型节点
  const [selectSmsType, setSelectSmsType] = useState([false, false, false, false, false]);

  // 本画布流程页可以进行保存、预执行、提交，但是一个活动只可以保存一次，其他情况的操作都是更新，所以通过本活动的processKey是否为空来标识是否已经保存过(为空-未保存)
  const [isSave, setSave] = useState(false);
  // 判断这个流程有没有处于正在保存的请求中，防连击
  const [inSaveProcess, setInSaveProcess] = useState(false);

  // 活动信息
  const [activityInfo, setActivityInfo] = useState({});

  // 运行信息
  const [runInfo, changeRunInfo] = useReducer(
    (prevInfo, newInfo = {}) => {
      const info = {
        ...prevInfo,
        ...newInfo,
      };
      info.currentCycleState = info.cycles[info.currentCycleIndex] || {
        actInsts: [],
        state: -1,
      };
      return info;
    },
    {
      cycles: [],
      currentCycleIndex: null,
      currentCycleState: {
        actInsts: [],
        state: -1,
      },
    }
  );

  // 装载canvas的div dom元素
  const canvasRef = useRef<HTMLDivElement>(null);

  // 画布信息
  const [canvasInfo, changeCanvasInfo] = useReducer(
    (prevInfo, newInfo) => {
      return {
        ...prevInfo,
        ...newInfo,
      };
    },
    {
      size: {
        width: 0,
        height: 0,
      },
      hasGrid: true,
    }
  );

  // graph实例
  const [graph, setGraph] = useState(null);

  // 初始的页面节点和连接线的信息记录
  const [baseData, setBaseData] = useState({
    nodes: [],
    edges: [],
  });

  // 初始化页面时，所有节点的x,y坐标，用来复制节点的时候防止重叠
  const [coordinate, setCoordinate] = useState({
    nodes: [],
  });

  // 当前编辑的节点
  const [currentNode, setCurrentNode] = useState<Node>();
  // 当前节点的运行状态
  const currentNodeRunState = useMemo(() => {
    return (
      runInfo.currentCycleState.actInsts
        .filter((state) => state.resourceId === currentNode?.nodeId)
        .map((state) => ({
          nodeId: state.resourceId,
          variables: state.actVariableData,
          activityInfo: state.actInstData,
        }))[0] || {}
    );
  }, [currentNode?.nodeId, runInfo.currentCycleIndex]);
  // 当前节点的前置节点，不再使用useMemo是因为nodeDate的更改没有及时更新到prevNodes里面
  // const prevNodes = useMemo(() => {
  //   const prevNodeIds = graph?.getPrevNodeIds(currentNode?.nodeId) || [];
  //   return nodeData.filter(node => prevNodeIds.indexOf(node?.nodeId) > -1)
  // }, [currentNode?.nodeId]);
  // const prevNodeIds = graph?.getPrevNodeIds(currentNode?.nodeId) || [];
  // const prevNodes = nodeData.filter(node => prevNodeIds.indexOf(node?.nodeId) > -1);

  /**
   * 根据节点id，查询节点的前置节点列表
   * @param id 要查询的节点的节点id
   */
  const getPrevNodes = (id) => {
    if (id) {
      const prevNodeIds = graph?.getPrevNodeIds(id) || [];
      return nodeData.filter((node) => prevNodeIds.indexOf(node?.nodeId) > -1);
    } else {
      return [];
    }
  };

  /**
   * 根据节点id，查询节点的后置节点列表
   * @param id 要查询的节点的节点id
   */
  const getNextNodes = (id) => {
    if (id) {
      const nextNodeIds = graph?.getNextNodeIds(id) || [];
      return nodeData.filter((node) => nextNodeIds.indexOf(node?.nodeId) > -1);
    } else {
      return [];
    }
  };

  // 弹窗相关
  const [winTitle, setWinTitle] = useState('');
  const [winShow, setWinShow] = useState(false);
  // loading
  const [isLoading, setIsLoading] = useState(false);
  /**
   * 获取已保存的活动信息
   */
  const getActivitySaveInfo = async () => {
    setIsLoading(true);
    const { data } = await CanvasService.getCanvasProcess({
      campaignId: pageInfo.campaignId,
    }).catch((e) => {
      console.log(e);
    });
    setIsLoading(false);
    return data;
  };
  /**
   * 获取预执行的状态
   */
  const getActivityPreviewInfo = async () => {
    setIsLoading(true);
    const { data } = await CanvasService.getCanvasProcessPreDetail({
      campaignId: pageInfo.campaignId,
    }).catch((e) => {
      console.log(e);
    });
    setIsLoading(false);
    return data;
  };

  /**
   * 获取详情
   */
  const getActivityDetail = async () => {
    setIsLoading(true);
    const { data } = await CanvasService.getCanvasProcessDetail({
      campaignId: pageInfo.campaignId,
    }).catch((e) => {
      console.log(e);
    });
    setIsLoading(false);
    return data;
  };

  /**
   * 获取初始化的方法
   */
  const getInitData = async () => {
    // 根据路由判断是初始创建/编辑/查看预执行详情/查看详情
    switch (match.params.type) {
      case PageType.editor: // 编辑页面
        return await getActivitySaveInfo();
      case PageType.preview: // 预执行页面
        return await getActivityPreviewInfo();
      case PageType.detail: // 详情页面
        return await getActivityDetail();
      default:
        return {};
    }
  };
  const wraperRef = useRef();
  const forceResetBtn = useRef();
  const resetGraphSize = () => {
    const canvasElm: HTMLDivElement = canvasRef.current!;
    const canvasWidth = canvasElm.clientWidth;
    const canvasHeight = canvasElm.clientHeight;
    graph?.changeGraphSize(canvasWidth, canvasHeight);
    changeCanvasInfo({
      //重设宽高
      size: {
        width: canvasWidth,
        height: canvasHeight,
      },
    });
  };

  /**
   * 初始化画布数据
   */
  const initCanvas = () => {
    // 获取画布空间的大小
    const canvasElm: HTMLDivElement = canvasRef.current!;
    const canvasWidth = canvasElm.clientWidth;
    const canvasHeight = canvasElm.clientHeight;
    changeCanvasInfo({
      size: {
        width: canvasWidth,
        height: canvasHeight,
      },
    });
    const g = Graph.create(
      canvasElm,
      canvasWidth,
      canvasHeight,
      match.params.type
    );
    // 绑定双击节点打开节点设置
    g.onNodeDblClick(nodeDblClickHandler);
    /**
     * 设置连接校验函数，用户在连线的时候判断节点是否可以连入
     */
    g.setLinkTargetValidator((sourceId, targetId) => {
      // 获取出发节点和进入节点的节点数据
      const sourceNode = nodeData.filter((n) => n.nodeId === sourceId)[0];
      const targetNode = nodeData.filter((n) => n.nodeId === targetId)[0];
      // 进入节点的已经连接的线数量
      const targetLinkCount = g
        .getInstance()
        .getEdges()
        .filter((edges) => edges._cfg.model.target === targetId).length;
      return (
        sourceId !== targetId && // 节点不能连接自己
        targetNode.info.inputType > 0 && // 要进入的节点需要可以输入
        sourceNode.info.outputType === targetNode.info.inputType && //出发节点输出和进入节点输入需要匹配
        targetLinkCount < targetNode.info.maxInputCount
      ); // 输入的数量在可允许的范围内
    });

    setGraph(g);
    return g;
  };
  /**
   * 初始化绘图
   */
  const initGraph = async (model = null) => {
    let {
      campaign = {},
      processDesignModel = {
        childShapes: [],
      },
      processRuntimeData = [],
    } = await getInitData();

    // 如果是应用模板，就把这个childShapes赋上去
    if (model) {
      const temp = JSON.parse(JSON.stringify(processDesignModel));
      temp.childShapes = JSON.parse(JSON.stringify(model));
      processDesignModel = temp;
    }

    const { childShapes = [], ...info } = processDesignModel;

    setSave(campaign.processKey ? true : false);

    // 清理一下节点数据
    nodeData.length = 0;

    const bData = {
      nodes: [],
      edges: [],
    };
    const cData = {
      nodes: [],
    };
    // 用于记录线的数据
    const lines = [];
    childShapes
      .filter((item) => item.resourceType.toUpperCase() !== 'LINE')
      .forEach((item) => {
        // 这个元素是个节点，在节点列表中根据节点的resourceType匹配节点的前端数据
        const node = allNodes.filter(
          (n) => n.info.name === item.resourceType
        )[0];
        // nodeData中存节点的信息
        nodeData.push({
          nodeId: item.resourceId,
          ...node.create(item.formProperties),
        });
        // 将节点的信息添加到绘图原始数据中
        bData.nodes.push({
          id: item.resourceId,
          x: item.bounds.lowerRight.x,
          y: item.bounds.lowerRight.y,
          info: node.info,
          data: item.formProperties,
        });
        cData.nodes.push({
          x: item.bounds.lowerRight.x,
          y: item.bounds.lowerRight.y,
        });

        if (Array.isArray(item.outgoing)) {
          item.outgoing.forEach((line) =>
            lines.push({
              source: item.resourceId,
              id: line.resourceId,
            })
          );
        }
      });

    // 遍历返回的线
    childShapes
      .filter((item) => item.resourceType.toUpperCase() === 'LINE')
      .forEach((item) => {
        // 找到每一条线的id和source，绘制在绘图区域
        lines
          .filter((line) => line.id === item.resourceId)
          .forEach((line) =>
            bData.edges.push({
              id: line.id,
              source: line.source,
              target: item.outgoing[0].resourceId,
            })
          );
      });
    setBaseData(bData);
    setCoordinate(cData);
    // 将活动信息写入activityInfo
    setActivityInfo({
      ...campaign,
      ...info,
      campaignId: pageInfo.campaignId
    });
    // 将活动运行的信息写入activityCycles
    // 将最后一次运行的信息设置为当前展示的信息
    changeRunInfo({
      cycles: processRuntimeData,
      currentCycleIndex: processRuntimeData.length - 1,
    });
  };

  /**
   * 绘制页面的初始数据
   */
  const renderInitGraph = () => {
    if (graph && baseData.nodes.length > 0) {
      const state = {};
      runInfo.currentCycleState.actInsts.forEach((node) => {
        state[node.resourceId] = {
          state: node.actInstData,
          variables: node.actVariableData?.[0],
        };
      });
      graph.render(baseData, state);
    }
  };

  // 页面进入的时候初始化画布
  useEffect(() => {
    // 初始化画布
    initCanvas();
  }, []);

  /**
   * @description: 判断版本，得到可操作的节点数
   * @param {*} v 版本
   * @param {*} s shopId
   * @return {*}
   */
  const judgeVersion = (v, s) => {
    if (v === '4' || prodValue === 'crm') { // 如果是尊享版或当前系统是云鹿，就可操作多个
      // 判断当前用户可以操作多少个节点
      setPower(true);
    } else {
      let param = {
        listKey: 'crowd_canvas',
        listType: 1, //1白名单 0黑名单
      };
      CanvasService.getCanvasPower(param)
        .then((res) => {
          const getWhiteListArr = res.data; //获取的白名单数组
          const inWhiteList = getWhiteListArr.includes(Number(s)); //当前shopId是否在白名单当中
          setPower(inWhiteList);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  // 根据页面类型获取页面的初始化数据
  useEffect(() => {
      initGraph();
  }, [match.params.type]);

  // 切换循环周期的时候要重新绘制视图
  useEffect(() => {
    renderInitGraph();
  }, [baseData, runInfo.currentCycleIndex]);

  // 创建副本及复制粘贴共用的生成新节点的方法
  const createNewNode = (nodes, edges) => {
    // 有选中元素
    const oldNewNodeMap = new Map(); // 新旧节点key value组成的map,用于复制线的时候，查看线的旧起止节点，找到新起止节点
    const newNodeIds = [];
    nodes.forEach((nodeId) => {
      const dataVal = JSON.parse(
        JSON.stringify(nodeData.filter((node) => node.nodeId === nodeId)[0])
      );
      const newNodeId = UUID.getUUID32();
      const originName =
      dataVal.data.name === ''
          ? dataVal.info.label
          : dataVal.data.name.split('_copy')[0];
      let namebuf = `${originName}_copy_${copyIndex++}`;
      const label =
        namebuf.length > 24
          ? `${dataVal.info.label} ${UUID.getNowTime()}_copy_${copyIndex++}`
          : namebuf;
      // 拿到初始定义的所有节点信息，匹配类型后，工厂方法制造出带有components的节点
      const node = allNodes.filter((n) => n.info.name === dataVal.info.name)[0];
      dataVal.data.name = label;
      if(dataVal.info.name === "MARKETING_RICH_TEXT_SMS") {
        dataVal.data.templateContent = {};
        dataVal.data.templateId = '';
        dataVal.data.templateName = '';
      }
      nodeData.push({
        ...dataVal,
        nodeId: newNodeId,
        ...node.create(dataVal.data), // 用源节点所填信息，创建出复制节点的所有弹窗信息
      });
      oldNewNodeMap.set(nodeId, newNodeId); // 把被复制的节点的新旧Id放入map中
      graph.copyNode(nodeId, newNodeId, { label }, coordinate, dataVal.info.name);
      newNodeIds.push(newNodeId);
    });
    graph.createComboForCopy(newNodeIds);
    edges.forEach((edgeId) => {
      const sourceNodeId = edgeId._cfg.model.source;
      const targetNodeId = edgeId._cfg.model.target;
      graph.addEdge(
        UUID.getUUID32(),
        oldNewNodeMap.get(sourceNodeId),
        oldNewNodeMap.get(targetNodeId)
      );
    });
    // graph.clearAllStates(); // 如果是鼠标右键的创建副本功能，会把选中状态清掉，后续都不能再获取到当前节点，所以暂时注掉，后续跟进看会不会有问题
  }

  // 快捷键复制时，存放当前所选的节点和边
  let copyNodes = [];
  let copyEdges = [];

  // ctrl+c复制，存储当前选中的节点及边
  const copySelectItems = () => {
    graph.packUpContextMenu(); // 清除鼠标右键节点事件
    const arNodes = graph.getFocusItems();
    const arEdges = graph.getFocusEdges();
    if (arNodes.length > 0) {
      copyNodes = JSON.parse(JSON.stringify(arNodes));
    }
    if (arEdges.length > 0) {
      copyEdges = arEdges.map(i => i._cfg.model)
    }
    // LzMsg.success('复制成功！');
  }
  // 粘贴方法
  const pasteItems = () => {
    if (copyNodes.length > 0) {
      const ar = nodeData.filter((node) => {
        return copyNodes.indexOf(node.nodeId) > -1 && (node.info.name === 'CROWD_DIG' || node.info.name === 'CROWD_DIG_BATCH')
      })
      if (ar.length + strategyNodeNumBeyond() > 150) {
        // 人群选择节点超过150弹出提示
        setCrowdNodeNumDialog(true);
      } else {
        createNewNode(copyNodes, copyEdges);
        LzMsg.success('粘贴成功！')
      }
    }
  }

  const listeningKeyUp = event => {
    const canvasType = match.params.type;
    // switch (event.code) {
    // 20250411 取消所有关于节点的键盘监听事件， worktile_id
    //   case 'KeyC':
    //     // C键，复制
    //     if (canvasType === 'editor' && event.ctrlKey) {
    //       copySelectItems();
    //       graph.setMode('default'); // 把画布状态重置为默认，不然ctrl的键盘事件使画布还保留在chooseMode状态
    //     }
    //     break;
    //   case 'KeyV':
    //     // V键，粘贴
    //     if (canvasType === 'editor' && event.ctrlKey) {
    //       pasteItems();
    //       graph.setMode('default');
    //     }
    //     break;
    //   case 'KeyD':
    //     // D键，创建副本 即CTRL C+V
    //     if (canvasType === 'editor' && event.ctrlKey) {
    //       event.preventDefault(); // 去除默认
    //       copyFocusItems();
    //       graph.setMode('default');
    //     }
    //     break;
    // }
  };
  // event.on('copySelectItems', (from) => {
  //   copySelectItems();
  // })
  // event.on('pasteItems', (from) => {
  //   pasteItems();
  // })
  // 监听复制粘贴键盘事件，由于nodeData等参数无法同步到Graph.ts里，所以在这强行监听
//   let eventListener = 0;
//   useEffect(() => {
//     if (graph && eventListener != 1) {
//       eventListener = 1;
//       window.addEventListener('keyup', listeningKeyUp);
//     }
//     return () => {
//       // 清除监听
//       window.removeEventListener('keyup', listeningKeyUp);
//       eventListener = 0;
//       copyNodes = [];
//       copyEdges = [];
//     };
//   }, [graph]);

  // 窗口缩放的时候要重新设置画布宽高
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      forceResetBtn?.current?.click();
    });
    resizeObserver.observe(wraperRef?.current);
  }, []);

  /**
   * 节点被双击的事件处理函数
   */
  const nodeDblClickHandler = useCallback(
    (id) => {
      // 获取当前被点击的节点
      const nodeClicked = nodeData.filter((node) => node.nodeId === id)[0];
      setCurrentNode(nodeClicked);
      setWinTitle(nodeClicked.info.label);
      setWinShow(true);
    },
    [runInfo]
  );

  /**
   * 人群批量选择、批量拆分节点拖拽后默认直接打开弹窗
   */
  const automaticOpenNode = (id, type = 'select_crowd') => {
    if(type === 'select_crowd' && strategyNodeNumBeyond() > 150){
        setCrowdNodeNumDialog(true);
        return false;
    }
    const nodeClicked = nodeData.filter((node) => node.nodeId === id)[0];
    setCurrentNode(nodeClicked);
    setWinTitle(nodeClicked.info.label);
    setWinShow(true);
  };

  /**
   * 判断当前画布活动人群选择节点是否超出150
   */
  const strategyNodeNumBeyond = () => {
    const allNodeTypesArr = getAllNodesOnGraph();
    const strategyNodesArr = allNodeTypesArr.filter(item => item === 'node-CROWD_DIG-2' || item === 'node-CROWD-2');
    return strategyNodesArr.length;
  };
  /**
   * 判断当前画布活动人群分析节点是否超出10
   */
  const crowdEffectNodeNumBeyond = () => {
    const allNodeTypesArr = getAllNodesOnGraph();
    const strategyNodesArr = allNodeTypesArr.filter(item => item === 'node-MARKETING_CROWD_BEHAVIOR_ANALYSIS-2');
    return strategyNodesArr.length;
  };

  /**
 * 现有人群节点数量
 */
  const strategyNodeNums = () => {
    const allNodeTypesArr = getAllNodesOnGraph();
    return allNodeTypesArr.filter(item => item === 'node-CROWD_DIG-2' || item === 'node-CROWD-2').length;
  }

  /**
   * 检测
   */
  // 这段代码写的错漏百出，注掉留着批判一下
  // const checkAllNodes = async () => {
  //   // 获取到绘图区域的节点
  //   const graphNodeIds = graph.getAllNodeIds();
  //   // 对有效节点进行校验
  //   nodeData.filter(n => graphNodeIds.indexOf(n.nodeId) > -1).forEach(node => {
  //     // 校验输入数量
  //     const inputCount = graph.getPrevNodeIds(node.nodeId).length;
  //     if (inputCount < node.info.minInputCount) {
  //       const errorMessage = `${node.info.label}节点设置有误：前置节点数量不少于${node.info.minInputCount}`;
  //       graph.setItemState(node.nodeId, 'success', false);
  //       graph.setItemState(node.nodeId, 'error', true);
  //       throw new Error(errorMessage);
  //     }
  //     if (inputCount > node.info.minInputCount) {
  //       const errorMessage = `${node.info.label}节点设置有误：前置节点数量不大于${node.info.maxInputCount}`;
  //       graph.setItemState(node.nodeId, 'success', false);
  //       graph.setItemState(node.nodeId, 'error', true);
  //       LzMsg.error(errorMessage);
  //       throw new Error(errorMessage);
  //     }
  //     // 遍历节点的验证方法集
  //     Object.keys(node.validators).forEach(async validator => {
  //       // 如果一个字段同时存在于验证方法集和数据里面则使用对应的验证方法校验对应字段的数据
  //       if (validator in node.data) {
  //         try {
  //           await node.validators[validator](node.data[validator]);
  //         } catch (e) {
  //           graph.setItemState(node.nodeId, 'success', false);
  //           graph.setItemState(node.nodeId, 'error', true);
  //           throw e
  //         }
  //       }
  //     });
  //     graph.setItemState(node.nodeId, 'error', false);
  //     graph.setItemState(node.nodeId, 'success', true);
  //   });
  // };

  // 注：函数体里面这个Promise.all
  // 这里要对每个节点进行校验，而每个节点的校验方法都是异步的，
  // 如果使用Promise，只需要在catch中做好对应的逻辑，然后reject，就没有什么问题
  // 如果是对节点列表使用了数组的遍历方法同时使用的async/await 这里就要注意了，外层的try/catch只能对‘同步’（引号划重点）的流程进行异常捕获
  // 上面注掉的代码就是在forEach中使用了async修饰符，使得forEach中每个执行的函数体成为了一个返回promise的函数，
  // 但是forEach每次执行的函数流程并没有被await修饰，所以没有被划定到一个同步的流程中
  // 所以forEach中每次循环执行的函数抛出的异常无法被外层的try/catch捕获
  // type 如果是提交或者预执行，需要校验签名
  const checkAllNodes = async (type = null) => {
    // 保存之前所有节点做一下校验，节点校验成功与否保存到活动更新接口的checkPassFlag字段中，用于判断画布列表提交按钮状态是否可点击(画布节点校验全部通过提交按钮才可点击)
    // 获取到绘图区域的节点
    const graphNodeIds = graph.getAllNodeIds();
    if (!graphNodeIds.length) {
      throw new Error('请先针对此活动进行编辑');
    }
    let realSign = '';
    await Servlets('getTitle', {}).then(async (res: { data: string }) => {
      const { shopName } = res.data;
      await Servlets('getSmssign', { shopName }).then((res: { data: string }) => {
        if (!res.data) {
          return;
        }
        realSign = res.data;
      });
    });

    const timeDiffer = new Date(new Date().toDateString()).getTime();
    const maxTime = Math.max(
        new Date().getTime(),
        activityInfo.executionPlan.crowdStartTime
    )
    // 对有效节点进行校验
    await Promise.all(
      nodeData
        .filter((n) => graphNodeIds.indexOf(n.nodeId) > -1)
        .map(async (node) => {
          try {
            // 校验输入数量
            const inputCount = graph.getPrevNodeIds(node.nodeId).length;
            if (inputCount < node.info.minInputCount) {
              throw new Error(
                `该节点至少存在${node.info.minInputCount}个前置节点`
              );
            }
            if (inputCount > node.info.maxInputCount) {
              throw new Error(
                `该节点最多存在${node.info.maxInputCount}个前置节点`
              );
            }
            // 校验节点的输出数量
            const outputCount = graph.getNextNodeIds(node.nodeId).length;
            if (outputCount < node.info.minOutputCount) {
              throw new Error(
                `该节点至少存在${node.info.minOutputCount}个后置节点`
              );
            }
            if (outputCount > node.info.maxOutputCount) {
              throw new Error(
                `该节点最多存在${node.info.maxOutputCount}个后置节点`
              );
            }
            // 人群抽取节点，需要接上级的拆分或者去重，所以需要校验在保存之前有没有对前置节点做过修改
            if (node.info.name === 'CROWD_EXTRACT') {
              const preNodeList = getPrevNodes(node.nodeId);
              if (preNodeList.length < 1) { // 人群抽取节点可由上级去重节点直接生成，因此校验是否连接上级节点拿到这里，不在自己的里面校验，自己的拿不到相应节点信息
                throw new Error(`请确认是否连接上级节点`);
              } else {
                preNodeList.forEach((pre) => {
                  if (!node.data.extractType) {
                    // 如果是点击弹窗的关闭，或者直接连接上级节点但并未打开抽取弹窗进行编辑，就不能给preActName赋值，会把其余错误挡住，抽取节点提前判断一下其他表单内容
                    throw new Error(`人群抽取类型不能为空`);
                  }
                  if (
                    pre.data.name !== node.data.preActName &&
                    !node.data.extractType
                  ) {
                    throw new Error(`前置节点已被修改，请手动更新节点信息`);
                  }
                  if (pre.info.name === 'CROWD_DIFFERENCES') {
                    if (
                      pre.data.crowdNames.every(
                        (item) => item !== node.data.extractType
                      )
                    ) {
                      throw new Error(`前置节点已被修改，请手动更新节点信息`);
                    }
                  }
                  else if (pre.info.name === 'CROWD_SPLIT') {
                    if (
                      pre.data.splitCrowds.every(
                        (item) => item.searchName !== node.data.extractType
                      )
                    ) {
                      throw new Error(`前置节点已被修改，请手动更新节点信息`);
                    }
                  } else {
                    // 为其他节点预留
                  }
                });
              }
            }

            // 排除节点校验前置节点是否被修改
            if (node.info.name === 'CROWD_DIFFERENCE') {
              const preList = getPrevNodes(node.nodeId); // 页面所画出的前置节点数组
              const excludeList = JSON.parse(
                JSON.stringify(node.data.excludedNames)
              ); // 当前节点自带的与前置节点相关的数据

              const nodeList = excludeList.concat(node.data.crowdName); // 排除节点带有目标人群和排除人群，所以要累加起来才是所有的前置节点

              if (nodeList.length !== preList.length) {
                // 如果节点所带信息和页面所画前置节点不同，证明已经删除了某个前置节点
                throw new Error(`前置节点已被修改，请手动更新节点信息`);
              }

              preList.forEach((item) => {
                const realCheckName = ['CROWD_DIG', 'CROWD_DIG_BATCH'].indexOf(item.info.name) > -1 ? item.data.crowdName : item.data.name;
                if (
                  (item.info.name !== 'CROWD_EXTRACT' &&
                    nodeList.indexOf(realCheckName) === -1) ||
                  (item.info.name === 'CROWD_EXTRACT' &&
                    nodeList.indexOf(item.data.extractType) === -1)
                ) {
                  throw new Error(`前置节点已被修改，请手动更新节点信息`);
                }
              });
            }

            // 去重节点校验前置节点是否被修改，原理同排除节点
            if (node.info.name === 'CROWD_DIFFERENCES') {
              const preList = getPrevNodes(node.nodeId);
              const nodeList = node.data.crowdNames;
              if (nodeList.length !== preList.length) {
                throw new Error(`前置节点已被修改，请手动更新节点信息`);
              }
              preList.forEach((item) => {
                const realCheckName = ['CROWD_DIG', 'CROWD_DIG_BATCH'].indexOf(item.info.name) > -1 ? item.data.crowdName : item.data.name;
                if (
                  (item.info.name !== 'CROWD_EXTRACT' &&
                    node.data.crowdNames.indexOf(realCheckName) === -1) ||
                  (item.info.name === 'CROWD_EXTRACT' &&
                    node.data.crowdNames.indexOf(item.data.extractType) === -1)
                ) {
                  throw new Error(`前置节点已被修改，请手动更新节点信息`);
                }
              });
            }

            // N并1节点校验前置节点是否被修改
            if (node.info.name === 'CROWD_UNION_2') {
              const preList = getPrevNodes(node.nodeId); // 页面所画出的前置节点数组
              const aimList = JSON.parse(
                JSON.stringify(node.data.aimNames)
              ); // 当前节点自带的与前置节点相关的数据

              const nodeList = aimList.concat(node.data.crowdNames); // 排除节点带有目标人群和排除人群，所以要累加起来才是所有的前置节点

              if (nodeList.length !== preList.length) {
                // 如果节点所带信息和页面所画前置节点不同，证明已经删除了某个前置节点
                throw new Error(`前置节点已被修改，请手动更新节点信息`);
              }
              let prevNodesName = [];
              preList.forEach((item) => {
                const realCheckName = ['CROWD_DIG', 'CROWD_DIG_BATCH'].indexOf(item.info.name) > -1 ? item.data.crowdName : item.data.name;
                prevNodesName.push(realCheckName);
                if (
                  (item.info.name !== 'CROWD_EXTRACT' &&
                      nodeList.indexOf(realCheckName) === -1) ||
                    (item.info.name === 'CROWD_EXTRACT' &&
                      nodeList.indexOf(item.data.extractType) === -1)
                  ) {
                    throw new Error(`前置节点已被修改，请手动更新节点信息`);
                  }
              });
            }

            // N交1节点校验前置节点是否被修改
            if (node.info.name === 'CROWD_INTERSECTION_2') {
              const preList = getPrevNodes(node.nodeId); // 页面所画出的前置节点数组
              const aimList = JSON.parse(
                JSON.stringify(node.data.aimNames)
              ); // 当前节点自带的与前置节点相关的数据

              const nodeList = aimList.concat(node.data.crowdNames); // 排除节点带有目标人群和排除人群，所以要累加起来才是所有的前置节点

              if (nodeList.length !== preList.length) {
                // 如果节点所带信息和页面所画前置节点不同，证明已经删除了某个前置节点
                throw new Error(`前置节点已被修改，请手动更新节点信息`);
              }
              let prevNodesName = [];
              preList.forEach((item) => {
                const realCheckName = ['CROWD_DIG', 'CROWD_DIG_BATCH'].indexOf(item.info.name) > -1 ? item.data.crowdName : item.data.name;
                prevNodesName.push(realCheckName);
                if (
                  (item.info.name !== 'CROWD_EXTRACT' &&
                      nodeList.indexOf(realCheckName) === -1) ||
                    (item.info.name === 'CROWD_EXTRACT' &&
                      nodeList.indexOf(item.data.extractType) === -1)
                  ) {
                    throw new Error(`前置节点已被修改，请手动更新节点信息`);
                  }
              });
            }

            // 检测优惠券节点所选择的优惠券是否依然存在
            if (node.info.name === 'MARKETING_COUPON' && node.data.couponRecordId) {
              let coponCanUse;
              await CanvasService.checkrecordcanuse({ recordId: node.data.couponRecordId }).then(res => {
                coponCanUse = res.data;
              }).catch(e => {
                console.log(e)
              });
              if (!coponCanUse) {
                throw new Error('优惠券已不存在，请重新选择');
              }
            }

            // 校验节点的数据
            await node.validate();

            // 为时间修改的人群包分析新节点做最后的校验
            if (node.info.name === 'MARKETING_CROWD_BEHAVIOR_ANALYSIS') {
                if (Number(node.data.startTime) > Number(node.data.endTime)) {
                    throw new Error('该节点结束时间大于开始时间，请重新配置后再提交！');
                }
            }
            // 确保其他内容都没问题后，重新确认短信富信的短信签名和现有生效签名是否相同
            if (node.info.name === 'MARKETING_SMS' && (type === SaveType.submit || type === SaveType.pre)) {
                if (node.data.smsSign !== realSign) {
                    throw new Error('该节点的签名同当前店铺已生效的签名不符，请重新配置后再提交！');
                }
                if (activityInfo.executionPlan.type === 1 && node.data.executionTime !== 0 && node.data.executionTime < timeDiffer) {
                  throw new Error(`${node.data.name}节点已过期`);
                }
            }
            if (node.info.name === 'MARKETING_RICH_TEXT_SMS' && (type === SaveType.submit || type === SaveType.pre)) {
                if (node.data.sign !== realSign) {
                    throw new Error('该节点的签名同当前店铺已生效的签名不符，请重新配置后再提交！');
                }
                if (activityInfo.executionPlan.type === 1 && node.data.executionTime !== 0 && node.data.executionTime < timeDiffer) {
                    throw new Error(`${node.data.name}节点已过期`);
                }
            }
            graph.setItemState(node.nodeId, 'error', false);
            graph.setItemState(node.nodeId, 'success', true);
            graph.updateItem(node.nodeId, {
              runState: {
                success: true,
                error: false,
                errorMessage: '',
              },
            });
          } catch (e) {
            const errorMessage = `${node.info.label}节点设置有误：${e.message}`;
            graph.updateItem(node.nodeId, {
              runState: {
                success: false,
                error: true,
                errorMessage,
              },
            });
            graph.setItemState(node.nodeId, 'success', false);
            graph.setItemState(node.nodeId, 'error', true);
            throw new Error(errorMessage);
          }
        })
    );

    /**
     * 如果老老实实的写一个for循环，或者将这个函数写成Promise是不会出现什么问题的，
     * 实现方式如下：
     */
    // const nodeList = nodeData.filter(n => graphNodeIds.indexOf(n.nodeId) > -1)
    // for (let index = 0; index < nodeList.length; index ++) {
    //   // 遍历节点的验证方法集
    //   const node = nodeList[index];
    //   try {
    //     const inputCount = graph.getPrevNodeIds(node.nodeId).length;
    //     if (inputCount < node.info.minInputCount) {
    //       throw new Error(`前置节点数量不少于${node.info.minInputCount}`);
    //     }
    //     if (inputCount > node.info.maxInputCount) {
    //       throw new Error(`前置节点数量不大于${node.info.maxInputCount}`);
    //     }

    //     const outputCount = graph.getNextNodeIds(node.nodeId).length;
    //     if (outputCount < node.info.minOutputCount) {
    //       throw new Error(`后置节点数量不少于${node.info.minOutputCount}`);
    //     }
    //     if (outputCount > node.info.maxOutputCount) {
    //       throw new Error(`后置节点数量不大于${node.info.maxOutputCount}`);
    //     }
    //     await node.validate();
    //     graph.setItemState(node.nodeId, 'error', false);
    //     graph.setItemState(node.nodeId, 'success', true);
    //   } catch (e) {
    //     graph.setItemState(node.nodeId, 'success', false);
    //     graph.setItemState(node.nodeId, 'error', true);
    //     throw new Error(`${node.info.label}节点设置有误：${e.message}`);
    //   }
    // };
  };

  /**
   * 继续执行活动，校验是否有过期节点
   */
  const checkExpiredNode = async () => {
    const timeDiffer = new Date(new Date().toDateString()).getTime();
    const graphNodeIds = graph.getAllNodeIds();
    // 对有效节点进行校验
    await Promise.all(
      nodeData
        .filter((n) => graphNodeIds.indexOf(n.nodeId) > -1)
        .map(async (node) => {
          try {
            if (node.info.name === 'CROWD_DIG') {
              // if (node.data.executionTime < timeDiffer) {
              //   throw new Error(`${node.info.label}节点已过期`);
              // }
            }
            if (node.info.name === 'MARKETING_COUPON') {
              let coponCanUse;
              await CanvasService.checkrecordcanuse({ recordId: node.data.couponRecordId }).then(res => {
                coponCanUse = res.data;
              }).catch(e => {
                console.log(e)
              });
              if (!coponCanUse) {
                throw new Error('优惠券已不存在，请重新选择');
              }
            }
            if (node.info.name === 'MARKETING_SMS') {
              if (node.data.executionTime !== 0 && node.data.executionTime < timeDiffer) {
                throw new Error(`${node.info.label}节点已过期`);
              }
            }
            if (node.info.name === 'MARKETING_MSG_BOX') {
              if (node.data.executionTime < timeDiffer) {
                throw new Error(`${node.info.label}节点已过期`);
              }
            }
            if (node.info.name === 'MARKETING_RICH_TEXT_SMS') {
              if (node.data.executionTime !== 0 && node.data.executionTime < timeDiffer) {
                throw new Error(`${node.info.label}节点已过期`);
              }
            }
            graph.setItemState(node.nodeId, 'error', false);
            graph.setItemState(node.nodeId, 'success', true);
            graph.updateItem(node.nodeId, {
              runState: {
                success: true,
                error: false,
                errorMessage: '',
              },
            });
          } catch (e) {
            let errorMessage = e;
            // if (node.info.name === 'MARKETING_COUPON') {
            //   errorMessage = e;
            // } else {
            //   errorMessage = `${node.info.label}节点已过期`;
            // }
            graph.updateItem(node.nodeId, {
              runState: {
                success: false,
                error: true,
                errorMessage,
              },
            });
            graph.setItemState(node.nodeId, 'success', false);
            graph.setItemState(node.nodeId, 'error', true);
            throw new Error(errorMessage);
          }
        })
    );
  };

  /**
   * 节点删除功能
   */
  const [deleteWinShow, setDeleteWinShow] = useState(false); // 删除提示弹窗
  const [deletePrompInfo, setDeletePrompInfo] = useState('是否删除该组件?'); // 删除弹窗提示语
  const [contextNodeId, setContextNodeId] = useState(''); // 删除的节点id
  /**
   * 删除之前看是否有选中的元素(节点或连线), 有弹出删除弹窗
   * @param type 默认值normal代表是toolbar的按钮或delete键盘的删除；传入值contextmenu代表右键事件删除（右键涉及到当前画布内可能有多个选中节点，所以不能单纯靠getFocusItems()判断，而是取右击时存的节点id）
   */
  // TODO 对于去重/拆分节点的计算有问题，如果选了多个节点，就读取不到了，因为当前选的是getFocusItems()[0]
  const toDelete = (type = 'normal') => {
    const focusNum = graph.getFocusNode(); // 全局被选中的节点个数
    let toDeleteNode = graph.getFocusItems()[0]; // 当前要被删除的节点

    if (type === 'contextmenu') { // 如果是鼠标右键触发的删除事件
      graph.packUpContextMenu(); // 清除鼠标右键节点事件
      const currOperationNode = sessionStorage.getItem('lz-cjyx-canvas-contextmenu-node'); // 当前右键操作的节点
      toDeleteNode = currOperationNode ?? toDeleteNode;
    }
    let toDeleteNodeNextNodes = getNextNodes(toDeleteNode); // 拿到要被删除节点的所有后置节点
    setContextNodeId(toDeleteNode);
    if (focusNum > 0) {
      if(graph.getNodeById(toDeleteNode)?._cfg.model.type === "node-CROWD_DIFFERENCES-2"){ //要被删除的节点是去重节点，设置删除文案
        setDeletePrompInfo('将要删除“去重”类型节点，删除该类型节点的同时会删除该节点的后置的人群抽取节点！');
      }
      if(toDeleteNodeNextNodes.length > 0){
        toDeleteNodeNextNodes.forEach(item => {
          if(item.info.nodeType === "node-CROWD_DIFFERENCES-2"){ // 如果后置节点有去重节点
            setDeletePrompInfo('该节点后置节点中有“去重”类型节点，若要删除该节点，则该节点去重后相应的人群抽取节点也将被删除!');
          }
        })
      }
      if(graph.getNodeById(toDeleteNode)?._cfg.model.type === "node-CROWD_SPLIT-2"){ //要被删除的节点是去重节点，设置删除文案
        setDeletePrompInfo('将要删除“拆分”类型节点，删除该类型节点的同时会删除该节点的后置的人群抽取节点！');
      }
      if(toDeleteNodeNextNodes.length > 0){
        toDeleteNodeNextNodes.forEach(item => {
          if(item.info.nodeType === "node-CROWD_SPLIT-2"){ // 如果后置节点有去重节点
            setDeletePrompInfo('该节点后置节点中有“拆分”类型节点，若要删除该节点，则该节点去重后相应的人群抽取节点也将被删除!');
          }
        })
      }
      else{
        setDeletePrompInfo('是否删除该组件?');
      }
      setDeleteWinShow(true);
    }
  }
  const deleteFocusItems = async () => {
    // 当要被删除的节点类型为“去重”时，删除该去重节点的同时，删除它的所有后置节点，并且给用户提示信息
    if (graph.getNodeById(contextNodeId)?._cfg.model.type === "node-CROWD_DIFFERENCES-2" || graph.getNodeById(contextNodeId)?._cfg.model.type === "node-CROWD_SPLIT-2" || graph.getNodeById(contextNodeId)?._cfg.model.type === "node-MARKETING_SMS-2") {
      const nextNodeIds = graph.getNextNodeIds(contextNodeId);
      if (nextNodeIds.length > 0) {
        nextNodeIds.forEach(item => {
          graph.deleteNodeById(item);
          nodeData.splice(
            nodeData.findIndex((node) => {
              return node.nodeId === item;
            }),
            1
          );
        })
      }
      deleteFocusNode();
    }
    // 当要被删除的节点的后置节点为“去重”或“拆分”时，删除该节点的同时，查找当前节点的后置节点去重的后置节点人群抽取节点中是否有选择根据当前节点去重后生成的
    // 例如： 人群选择节点(人群1) -> 去重节点(人群1) -> 人群抽取节点(人群1)
    // 那么人群抽取节点的人群是来自人群选择节点的，则当删除"人群选择节点(人群1)"时，要同时删除"人群抽取节点(人群1)"，并且给用户提示信息
    const toDeleteNodeNextNodes = getNextNodes(contextNodeId); // 拿到要被删除节点的所有后置节点
    let deleteCrowdName = ''; //要被删除的节点的人群名称
    let deleteName = ''; //要被删除的节点的人群名称
    nodeData.forEach(item => { //从全部节点中找出要被删除的节点信息
      if (item.nodeId === contextNodeId) {
        deleteCrowdName = item.data.crowdName; //人群选择节点取crowdName
        deleteName = item.data.name; //排除节点取name
      }
    })
    if (toDeleteNodeNextNodes.length > 0) {
      toDeleteNodeNextNodes.forEach(item => {
        if (item.info.nodeType === "node-CROWD_DIFFERENCES-2") { // 如果后置节点有去重节点
          const duplicateRemoveNodeNextNodes = getNextNodes(item.nodeId); // 再拿到去重节点的所有后置节点
          duplicateRemoveNodeNextNodes.forEach(nextItem => {
            if (nextItem.data.extractType === deleteCrowdName || nextItem.data.extractType === deleteName) {
              graph.deleteNodeById(nextItem.nodeId);
              nodeData.splice(
                nodeData.findIndex((node) => {
                  return node.nodeId === nextItem.nodeId;
                }),
                1
              );
            }
          })
        }
        if (item.info.nodeType === "node-CROWD_SPLIT-2") { // 如果后置节点有拆分节点
            const splitNodeNextNodes = getNextNodes(item.nodeId); // 再拿到拆分节点的所有后置节点
            // 删除拆分节点的所有后置节点
            splitNodeNextNodes.forEach(nextItem => {
                graph.deleteNodeById(nextItem.nodeId);
                nodeData.splice(
                    nodeData.findIndex((node) => {
                        return node.nodeId === nextItem.nodeId;
                    }),
                    1
                );
            });
            // 删除拆分节点
            graph.deleteNodeById(item.nodeId);
            nodeData.splice(
                nodeData.findIndex((node) => {
                    return node.nodeId === item.nodeId;
                }),
                1
            );
        }
      })
      deleteFocusNode();
    }
    else {
      deleteFocusNode();
    }
  };
  // delete快捷键删除时，在graphsecond里没办法删除nodeData的数据，所以拿到这监听，删除
  // 很奇怪这个方法会进来多次，所以用index判断一下，如果当前nodeData里没有值了，就不用删
  event.on('delete-canvas-node', (item) => {
      const index = nodeData.findIndex((node) => node.nodeId === item?._cfg?.id);
      if (index > -1) {
          nodeData.splice(index, 1);
      }
  })
  // ctrl+Z和ctrl+Y时，要把节点恢复回来
  event.on('add-canvas-node', (item) => {
      const node = allNodes.filter(
          (n) => `node-${n.info.name}-2` === item.type
      )[0];
      if(!nodeData.find((e) => e.nodeId ===item.id)){
        nodeData.push({
          nodeId: item.id,
          // ...node.create(item.formProperties),
          ...node.create({
            "crowdId": item.id,
            "crowdName": item.label,
            ...item
          })
        });
      }
  });

  // 删除选中节点
  const deleteFocusNode = () => {
    // 删除当前选中节点
    const deleteNode = nodeData.findIndex((node) => {
      return node.nodeId === contextNodeId;
    });
    if (deleteNode !== -1) {
      //是节点才从nodeData中移除，是线不操作
      nodeData.splice(
        nodeData.findIndex((node) => {
          return node.nodeId === contextNodeId;
        }),
        1
      );
    }
    graph.deleteFocusItem();
  }

  /**
   * 创建副本功能,包含节点之间的连线
   */
  const copyFocusItems = async () => {
    graph.packUpContextMenu(); // 清除鼠标右键节点事件
    const focusItems = graph.getFocusItems();
    if (focusItems.length > 0) {
    //   const {data} = CanvasService.canvasCrowdEffectCount().catch((e) => {
    //     console.log(e);
    //   });
      const ar = nodeData.filter((node) => {
        return focusItems.indexOf(node.nodeId) > -1 && (node.info.name === 'CROWD_DIG' || node.info.name === 'CROWD_DIG_BATCH')
      })
    //   const len = nodeData.filter((node) => {
    //     return focusItems.indexOf(node.nodeId) > -1 && (node.info.name === 'MARKETING_CROWD_BEHAVIOR_ANALYSIS')
    //   })
      if (ar.length + strategyNodeNumBeyond() > 150) {
        // 人群选择节点超过150弹出提示
        setCrowdNodeNumDialog(true);
    //   }
    //   else if (len.length + crowdEffectNodeNumBeyond() + data?.count > 10) {
    //     setCrowdEffectNodeNumDialog(true);
      } else {
        createNewNode(focusItems, graph.getFocusEdges());
      }
    }
  };

  // 保存之前所有节点做一下校验，节点校验成功与否保存到活动更新接口的checkPassFlag字段中，用于判断画布列表提交按钮状态是否可点击(画布节点校验全部通过提交按钮才可点击)
  // type 为保存的时候，不弹出提示，其他时候弹出
  const changePassFlag = async (type) => {
    try {
      await checkAllNodes(type);
      updateActivityCheckPassFlag(1);
    } catch (e) {
        updateActivityCheckPassFlag(0);
        if (type !== SaveType.save) {
            throw new Error(e);
        }
    }
  }

  /**
   * 页面上点击保存、提交、预执行，整理好节点数据后需要执行的方法
   * @param type save-保存 pre-预执行 submit-提交
   */
  const continueFun = async (type) => {
    // 如果点击的是ToolBar里的保存，执行正常保存方法，然后获取保存信息重绘页面
    // 是Header里的预执行，先保存再预执行，切换页面到预执行状态
    // 是Header里的提交，保存再提交然后跳转回列表页
    try {
      if (type === SaveType.save) {
        initGraph();
        setInSaveProcess(false);
        LzMsg.success('保存成功');
        await changePassFlag(type);
      } else if (type === SaveType.pre) {
        initGraph();
        setInSaveProcess(false); //预执行之前先保存一下，否则有问题
        await changePassFlag(type);
        // 校验节点表单填的时间是否过期
        if (activityInfo.executionPlan.type === 1) {
          await checkExpiredNode();
        }
        CanvasService.preActivity({
          campaignId: pageInfo.campaignId,
        })
          .then((res) => {
            if(res.success) {
              setInSaveProcess(false);
              LzMsg.success('预执行成功');
              history.push(`/canvas/activities/${pageInfo.campaignId}/preview/`);
            } else {
              LzMsg.error(res.resp_msg);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else if (type === SaveType.submit) {
        await changePassFlag(type);
        if (activityInfo.executionPlan.type === 1) {
          await checkExpiredNode();
        }
        CanvasService.submitActivity({
          campaignId: pageInfo.campaignId,
        })
          .then((res) => {
            if(res.success) {
              setInSaveProcess(false);
              // 20220814 运营短信活动,先弹弹窗再回列表
              LzMsg.success('提交成功');
              history.push(`/canvas/activities`, { source: 'editor' });
              // checkShowDialog();
            } else {
              LzMsg.error(res.resp_msg);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else if (type === SaveType.stopPreview) {
          // 停止预执行
          await changePassFlag(type);
          history.push(`/canvas/activities/${pageInfo.campaignId}/editor/`);
        //   initCanvas();
        //   initGraph();
        //   setInSaveProcess(false);
          window.location.reload();
          LzMsg.success('预执行已停止');
      }
    } catch (e) {
      LzMsg.error(e.message);
      setInSaveProcess(false);
    }
  };

  /**
   * 保存按钮点击逻辑
   * @param target process-保存画布流程 template-另存为模板
   * @param type save-保存 pre-预执行 submit-提交
   * @param callbackFunction 回调函数，当是点击退出时，弹出的弹窗进行保存后关闭时，先执行保存方法，再跳回列表页
   */
    const save = async (target, type = SaveType.save, callbackFunction = () => { }) => {
    setInSaveProcess(true);
    try {
      const instance = graph?.getInstance();
      let edgeIndex = 0;
      const edgeMap = {};
      const childEdgeShapes = instance.getEdges().map((graphEdge) => {
        const resourceId = UUID.getUUID32(); // `EDGE_${Date.now()}_${edgeIndex ++ }`; // graphEdge._cfg.id,
        edgeMap[graphEdge._cfg.id] = resourceId;
        return {
          resourceId,
          resourceType: 'LINE',
          formProperties: {},
          // 节点输出的是线的id列表
          outgoing: [
            {
              resourceId: graphEdge._cfg.target._cfg.id,
            },
          ],
          // 坐标的计算只计算图标圆形外切正方形的左上/右下，后台模型需要。。。
          bounds: {
            // 左上角
            upperLeft: {
              x: graphEdge._cfg.model.startPoint.x,
              y: graphEdge._cfg.model.startPoint.y,
            },
            // 右下角
            lowerRight: {
              x: graphEdge._cfg.model.endPoint.x,
              y: graphEdge._cfg.model.endPoint.y,
            },
          },
        };
      });
      const childNodeShapes = instance.getNodes().map((graphNode) => {
        const nodeId = graphNode._cfg.id;
        const node = nodeData.filter((n) => n.nodeId === nodeId)[0];
        return {
          resourceId: nodeId,
          resourceType: node.info.name,
          formProperties: node.data,
          // 节点输出的是线的id列表
          outgoing: graphNode._cfg.edges
            .filter((edge) => edge._cfg.model.source === nodeId)
            .map((edge) => ({
              resourceId: edgeMap[edge._cfg.id],
            })),

          // 坐标的计算只计算图标圆形外切正方形的左上/右下，后台模型需要。
          bounds: {
            // 右下角
            lowerRight: {
              x: graphNode._cfg.model.x,
              y: graphNode._cfg.model.y,
            },
            // 左上角
            upperLeft: {
              x: graphNode._cfg.model.x,
              y: graphNode._cfg.model.y,
            },
          },
        };
      });
      const requestData = {
        campaignId: match.params?.campaignId,
        // resourceId: activityInfo?.resourceId || `graph-${Date.now()}`,
        resourceId: activityInfo?.resourceId || UUID.getUUID32(),
        childShapes: [...childNodeShapes, ...childEdgeShapes],
      };
      // 如果是提交或预执行方法，还是先走一下节点校验，然后进行接口调用
      if (type === SaveType.pre || type === SaveType.submit) {
        await checkAllNodes(type);
      }
      if (target === SaveTarget.process) {
        // 如果是保存流程
        if (isSave) {
          // 如果本次活动已经保存过，需要走更新接口
          if (type === SaveType.stopPreview) {
            requestData.resourceId = requestData.resourceId.substring(0,requestData.resourceId.length-5)
          }
          CanvasService.updateProcess(requestData)
            .then((res) => {
              if(res.success) {
                continueFun(type);
                callbackFunction();
              } else {
                LzMsg.error(res.resp_msg);
              }
            })
            .catch((error) => {
              setInSaveProcess(false);
            });
        } else {
          CanvasService.saveProcess(requestData)
            .then((res) => {
              if(res.success) {
                continueFun(type);
                callbackFunction();
              } else {
                LzMsg.error(res.resp_msg);
              }
            })
            .catch((error) => {
              setInSaveProcess(false);
            });
        }
      } else {
        // 是保存模板
        CanvasService.saveCanvasTemplate(requestData).then((res) => { });
      }
    } catch (e) {
      LzMsg.error(e.message);
      setInSaveProcess(false);
    }
  };

  /**校验节点后走一次更新活动信息接口，标记此条数据下的节点是否通过校验(用于画布列表提交按钮状态区分) */
  const updateActivityCheckPassFlag = (flag) => {
    CanvasService.updateActivityList({
      campaignId: activityInfo.campaignId,
      campaignName: activityInfo.campaignName,
      campaignRemark: activityInfo.campaignRemark,
      executionPlan: { ...activityInfo.executionPlan, checkPassFlag: flag },
    })
      .then((res) => {
        // console.log(flag);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  /**
   * 获取现有所有节点id
   */
  const getAllNodes = () => {
    return graph.getAllNodeIds();
  };

  /**
 * 获取现有所有节点的类型，组成数组
 */
  const getAllNodesOnGraph = () => {
    return graph.getAllNodes().map(v => v._cfg.model.type);
  };

  /**
   * 计算弹窗内容的组件
   */
  const getDialogContent = () => {
    if (currentNode?.nodeId && currentNode?.components) {
      const Content =
        match.params.type === 'editor'
          ? currentNode?.components.Form
          : currentNode.components.Info;
      return (
        <Content
          allNodeData={nodeData}
          prevNodes={getPrevNodes(currentNode?.nodeId).map((pn) => ({
            info: pn?.info || {},
            data: pn?.data || {},
          }))}
          nextNodes={getNextNodes(currentNode?.nodeId).map((pn) => ({
            info: pn?.info || {},
            data: pn?.data || {},
          }))}
          activityInfo={activityInfo}
          runState={currentNodeRunState}
          initData={currentNode.data}
          currentNode={currentNode}
          changeData={(data) => {
            setWinShow(false);
            currentNode.changeData(data);
            graph.updateItem(currentNode.nodeId, {
              label:
                typeof data.name === 'string' && data.name !== ''
                  ? data.name
                  : currentNode.info.label,
            });
          }}
          onCancel={closeDialog}
          validate={currentNode.validators}
          getAllNodeIds={getAllNodes()}
        />
      );
    } else {
      return null;
    }
  };

  const closeDialog = () => {
    setWinShow(false);
    if (currentNode.info.name === "CROWD_DIG_BATCH" || currentNode.info.name === "CROWD_SPLIT_2") {
      graph.deleteNodeById(currentNode.nodeId); // 人群节点生成后，删除人群批量选择节点
    }
  }

  const [isRichMsg, setRichMsg] = useState(false); // 富信是否开白默认false
  useEffect(() => {
    // CanvasService.getQualificationsInfo()
    // .then((res) => {
    //   if (Number(res?.data?.status) !== 1) {
    //     setRichMsg(false);
    //   } else {
    //     setRichMsg(true);
    //   }
    // })
    // .catch((e) => {
    //   console.log(e);
    // });
  }, [])

  const [showInsertNodeList, setShowInsertNodeList] = useState(false); // 是否展示插入后置节点的菜单，鼠标移入事件改变其值
  const [hasInsertNodeList, setHasInsertNodeList] = useState(false); // 当前操作的节点，是否有可以连接的后置节点，鼠标移入后的判断方法里，看有节点可连，就改变其值
  const [insertNodeList, setInsertNodeList] = useState({}); // 右键菜单展示的可以连接的节点列表
  const [sameNodeSelection, setSameNodeSelection] = useState(false); // 多选的是否是同一类型节点
  // 计算能够连哪些后置节点
  const calcInsertNodeList = () => {
    // 所有节点类型
    let noeType = {
      sourceNodes: {
        label: '人群获取',
        node: []
      },
      operationNodes: {
        label: '人群操作',
        node: []
      },
      taskNodes: {
        label: '营销触点',
        node: []
      },
    //   interestNodes: {
    //     label: '客户权益',
    //     node: []
    //   }
    };
    const focusNode = graph.getFocusNodes();
    if (focusNode.length > 1) {
      const specialNode = ['node-CROWD_EXTRACT-2', 'node-CROWD_DIG-2'];
      const val = focusNode[0]._cfg.model.type; // 目标节点类型
      const real = specialNode.indexOf(val) > -1; // 是否是人群节点||抽取节点
      const aw = focusNode.every(ele => specialNode.indexOf(ele._cfg.model.type) > -1)
      setSameNodeSelection(real ? focusNode.every(ele => specialNode.indexOf(ele._cfg.model.type) > -1) : focusNode.every(ele => ele._cfg.model.type === val)); // 判断是否所有带有选中状态的节点类型都一样，如果一样，可以一起连后置节点，如果不一样，就只自己连后置节点
    }
    if (focusNode.length) {
      const curNode = allNodes.filter(
        (n) => `node-${n.info.name}-2` === graph.getNodeById(sessionStorage.getItem('lz-cjyx-canvas-contextmenu-node'))?._cfg.model.type
      )[0];
      // 当前选中节点的输出类型符合节点的输入类型，就记录下来
      let nums = 0;
      Object.keys(contextMenuNode).forEach((type) => {
        contextMenuNode[type].forEach((node) => {
            if (curNode.info.outputType === node.info.inputType && curNode.info.maxOutputCount > 0) {
                const typeList = ['MARKETING_MSG_BOX', 'MARKETING_PACKAGE_ANALYSIS', 'MARKETING_RICH_SMS', 'MARKETING_RICH_TEXT_SMS', 'MARKETING_CROWD_BEHAVIOR_ANALYSIS', 'BATCH_SMS', 'MARKETING_DONGDONG'];
                // 富信未开通、循环活动下的富信、优惠促销、人群包分析、批量短信、咚咚都不可作为后置节点插入
                if (activityInfo.executionPlan.type === 1) {
                    if (['MARKETING_RICH_SMS', 'MARKETING_RICH_TEXT_SMS'].indexOf(node.info.name) > -1) {
                        if (isRichMsg && node.info.name !== 'MARKETING_RICH_SMS') {
                            noeType[type].node.push(node);
                            nums += 1;
                        }
                    } else {
                        noeType[type].node.push(node);
                        nums += 1;
                    }
                } else {
                    if ((typeList.indexOf(node.info.name) === -1)) {
                        noeType[type].node.push(node);
                        nums += 1;
                    }
                }
          }
        })
      })
      if (nums > 0) {
        setInsertNodeList(noeType);
        setHasInsertNodeList(true);
      }
      setShowInsertNodeList(true);
    }
  }
  // 创建并连接后置节点
  const connectPostPositionNode = (node) => {
    graph.packUpContextMenu(); // 清除鼠标右键节点事件
    // 移除document上的事件绑定
    document.onmousemove = null;
    document.onmouseup = null;
    document.onmouseleave = null;

    // 创建新的节点
    const createNode = (sourceNode, targetNode, nodeId, name = '') => {
      const nodeDataLabel = name != '' ? `${targetNode.info.label}-${name}` : `${targetNode.info.label}-${UUID.getNowTime()}`; // 节点名称
      // 在节点数据中添加节点信息
      nodeData.push({
        nodeId,
        ...node.create(),
      });
      nodeData.forEach(item => {
          if (item.nodeId === nodeId) {
              item.data.name = nodeDataLabel
          }
      })
      const batchNodeX = sourceNode?._cfg?.model?.x;
      const batchNodeY = sourceNode?._cfg?.model?.y;
      const point = graph.getClientByPoint(batchNodeX, batchNodeY); // 将渲染坐标转换为屏幕/页面坐标
      graph.addNode(nodeId, targetNode, point.x + 400, point.y);
    //   // 赋值节点信息
    //   const createNodeInfo = nodeData.filter((node) => node?.nodeId === nodeId)[0];
      // 给节点名称赋值
      graph.updateItem(nodeId, {
        label: nodeDataLabel,
      });
    }
    // 与新节点连接
    const linkNode = (sourceNode, nodeId) => {
      try {
        // 赋值节点信息
        const createNodeInfo = nodeData.filter((node) => node?.nodeId === nodeId)[0];
        // 连接当前新生成的节点
        graph.addEdge(
          UUID.getUUID32(),
          sourceNode?._cfg?.model?.id,
          createNodeInfo.nodeId
        );
      } catch (e) {
        console.log(e);
      }
    }

    // 批量操作插入后置节点，需要判断节点类型，再给新节点拼名字
    const nodeType = [
        ['MARKETING_MSG_BOX'],
        ['CROWD_EXTRACT', 'CROWD_DIFFERENCES', 'CROWD_DIFFERENCE', 'CROWD_INTERSECTION', 'CROWD_UNION', 'CROWD_SPLIT', 'CROWD_SPLIT_2', 'CROWD_UNION_2', 'CROWD_INTERSECTION_2'],
        ['CROWD_DIG', 'MARKETING_CROWD_BEHAVIOR_ANALYSIS', 'MARKETING_PACKAGE_ANALYSIS', 'CROWD_PRESERVATION', 'MARKETING_RICH_TEXT_SMS'],
        ['MARKETING_SMS', 'MARKETING_DONGDONG']
    ];
    const nodeLabelLength = [20, 24, 32, 80];

    const currentNode = graph.getFocusNodes();
    // 如果当前选中的所有节点不是同一类型，那就只有右键的这个节点自己计算后置节点，如果是同一类型，那就大家一起连接
    if (!sameNodeSelection) {
      const sourceNode = graph.getNodeById(sessionStorage.getItem('lz-cjyx-canvas-contextmenu-node'));
      const nodeId = UUID.getUUID32();
      createNode(sourceNode, node, nodeId);
      linkNode(sourceNode, nodeId);
    } else {
      // 如果当前选中节点数量大于后置节点可输入的数量，就不能连接了。同时这个也印证了，可输入数量大于1，所有节点可以连到一个节点上，而不用生成多个后置节点。
      if (currentNode.length > node.info.maxInputCount && node.info.maxInputCount > 1) {
        LzMsg.error('所选节点数量过多，请减少');
      } else if (node.info.maxInputCount > 1) {
        const sourceNode = currentNode[0]; // 多个节点一起连一个后置节点，取一个源位置
        const nodeId = UUID.getUUID32();
        createNode(sourceNode, node, nodeId);
        currentNode.forEach(item => {
          linkNode(item, nodeId);
        })
      } else {
        // 选择了多个节点，每个节点连一个专属后置节点
        currentNode.forEach((item, index) => {
          const nodeId = UUID.getUUID32();
          // 为避免一对一连出去的节点重名，这里判断一下出发节点是不是名称重复，如重复就改变一下
          const len = currentNode.filter(it => it._cfg.model.label === item._cfg.model.label);
          // 根据节点类型，获取后置节点名称最大长度
          const labelLength = nodeLabelLength[nodeType.findIndex(item => item.includes(node.info.name))];
          // 这里的 - (node.info.label ~~)，是加上后置节点类型名还有连字符还有index，总和不能超过新节点的最大长度。因为如果有相同名称的前置节点，就还要拼接上 -index ，所以要根据是否有重名，来判断到底需要减去哪些长度
          const subtractLength = len.length > 1 ? (node.info.label.length + 1 + currentNode.length.toString().length) : (node.info.label.length + 1);
          const realName = (item._cfg.model.label.length + subtractLength) >= labelLength ? item._cfg.model.label.substring(0, labelLength - subtractLength) : item._cfg.model.label;
          createNode(item, node, nodeId, len.length > 1 ? `${realName}-${index}` : realName);
          linkNode(item, nodeId);
        })
      }
    }
  }

    // 批量设置短信富信节点执行时间
    const setNodeExecuteTime = (type, time) => {
        const getVal = (index: number): number => {
            return moment(type[index] ? time[index] : commonSendTime[index]).valueOf()
        }
        setSelectSmsType(type);
        const smsSendTime = getVal(0);
        const richSmsSendTime = getVal(1);
        const packageTime = getVal(2);
        const effectDataStartTime = getVal(3);
        const effectDataEndTime = getVal(4);
        setCommonSmsSendTime([smsSendTime, richSmsSendTime, packageTime, effectDataStartTime, effectDataEndTime]);

        //   nodeData.filter(item => item.info.name === "MARKETING_SMS")
        nodeData.forEach(item => {
            if (item.info.name === "MARKETING_SMS" && type[0]) {
                item.data.executionTime = smsSendTime; // 修改data内的值，让每次打开弹窗时的值，变更为当前设置的
                // 更新graph的值，这个视觉效果是短信富信节点上的发送时间的展示
                item.data.smsTimeDifference = 1; // 设置短信发送时间类型【立即发送 || 指定时间】
                item.data.cycleType = 1; // 设置活动类型 1单次 2循环
                graph.updateItem(item.nodeId, {
                    executionTime: moment(smsSendTime).format('YYYY-MM-DD HH:mm:ss')
                });
            };
            if (item.info.name === "MARKETING_RICH_TEXT_SMS" && type[1]) {
                item.data.executionTime = richSmsSendTime; // 修改data内的值，让每次打开弹窗时的值，变更为当前设置的
                // 更新graph的值，这个视觉效果是短信富信节点上的发送时间的展示
                graph.updateItem(item.nodeId, {
                    executionTime: moment(richSmsSendTime).format('YYYY-MM-DD HH:mm:ss')
                });
            };
            if (item.info.name === "MARKETING_PACKAGE_ANALYSIS" && type[2]) {
                item.data.startTime = packageTime;
            };
            if (item.info.name === "MARKETING_CROWD_BEHAVIOR_ANALYSIS" && type[3] && type[4]) {
                item.data.startTime = effectDataStartTime;
                item.data.endTime = effectDataEndTime;
                graph.updateItem(item.nodeId, {
                    executionTime: moment(effectDataStartTime).format('YYYY-MM-DD HH:mm:ss')
                });
            };
        })
    }

  return (
    <ActivityContext.Provider
      value={{
        powerInfo,
        pageInfo,
        isSave,
        inSaveProcess,
        activityInfo,
        runInfo,
        changeRunInfo,
        canvasInfo,
        changeCanvasInfo,
        isRichMsg,
        graph,
        baseData,
        resetGraph: graph?.resetPos,
        nodeData,
        checkAllNodes,
        checkExpiredNode,
        copyFocusItems,
        toDelete,
        getAllNodes,
        automaticOpenNode,
        getNextNodes,
        strategyNodeNumBeyond,
        strategyNodeNums,
        commonSendTime,
        selectSmsType,
        setNodeExecuteTime,
        crowdEffectNodeNumBeyond
      }}
    >
      <div className={`canvas-page ${styles['canvas-page']}`}>
        <Header
          save={(target, type, callbackFunction) => save(target, type, callbackFunction)}
          initGraph={initGraph}
        />
        <div className={styles['page-body']}>
          {/* {match.params.type !== PageType.detail && <Menu />} */}
          <Menu useTemplate={(model) => initGraph(model)} />
          <div className={styles['work-station']}>
            <p
              onClick={() => {
                resetGraphSize();
              }}
              ref={forceResetBtn}
              style={{ display: 'none' }}
            >
              重设宽高
            </p>
            <Toolbar save={(target, type) => save(target, type)} />
            <div className={styles['canvas-wrapper']} ref={wraperRef}>
              <div
                className={`${styles['canvas-element']} ${canvasInfo.hasGrid ? styles['grided'] : ''
                  }`}
                ref={canvasRef}
                // id='listen-ctrl-canvas-wrapper'
                style={{ cursor: 'default' }}
              >
                <div style={{ position: 'absolute', right: 10, top: 150, }}>
                  <div>提示：人群选择节点建议不超过85个</div>
                </div>
                {/* 在画布范围上右键 */}
                <ul id='contextMenuCanvas' className={styles['contextMenuCanvas']}>
                  <li onClick={() => graph.undo()}>
                    <div>撤销</div>
                    <div><span>Ctrl</span><span>Z</span></div>
                  </li>
                  {/* <li onClick={() => graph.redo()}>
                    <div>恢复</div>
                    <div><span>Ctrl</span><span>Y</span></div>
                  </li> */}
                  <li onClick={pasteItems}>
                    <div>粘贴</div>
                    {/* <div><span>Ctrl</span><span>V</span></div> */}
                  </li>
                  <li onClick={() => graph.selectAll()}>
                    <div>全选</div>
                    <div><span>Ctrl</span><span>A</span></div>
                  </li>
                </ul>
                {/* 在节点上右键 */}
                <ul id='contextMenuNode' className={styles['contextMenuNode']}>
                  <li onClick={() => toDelete('contextmenu')}>
                    <div>删除</div>
                    <div><span>Delete</span></div>
                  </li>
                  <li onClick={() => copySelectItems()}>
                    <div>复制</div>
                    {/* <div><span>Ctrl</span><span>C</span></div> */}
                  </li>
                  <li onClick={() => copyFocusItems()}>
                    <div>创建副本</div>
                    {/* <div><span>Ctrl</span><span>D</span></div> */}
                  </li>
                  <li onMouseEnter={() => calcInsertNodeList()} onMouseLeave={() => { setShowInsertNodeList(false);  setHasInsertNodeList(false)}}>
                    <div>插入后置节点</div>
                    <div className={`iconfont icon-down ${styles['insert-node-icon']}`}></div>
                    {
                      showInsertNodeList && <div className={styles['can-insert-node-list']} onMouseEnter={() => { setShowInsertNodeList(true); setHasInsertNodeList(true) }} onMouseLeave={() => { setShowInsertNodeList(false); setHasInsertNodeList(false) }}>
                        {
                          hasInsertNodeList ? <>
                          {
                            Object.keys(insertNodeList).map(type => <div className={styles['insert-node-classify']}>
                              {insertNodeList[type].node.length > 0 &&<div className={styles['insert-node-classify-label']}>{insertNodeList[type].label}</div>}
                              <div>
                                {
                                  insertNodeList[type].node.map(i => <div className={styles['insert-node-classify-list-item']} onClick={() => connectPostPositionNode(i)}>{i.info.label}</div>)
                                }
                              </div>
                            </div>)
                          }
                          </>
                            : <div style={{ textAlign: 'center'}}>无可连接的节点类型</div>
                        }
                      </div>
                    }
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <LzDialog
          shouldUpdatePosition
          isFullScreen
          title={winTitle}
          visible={winShow}
          footer={false}
          onCancel={closeDialog}
          onClose={closeDialog}
          style={{ minWidth: '487px' }}
          className={styles.graphDialog}
          closeMode={match.params.type === PageType.editor ? false : true}
        >
          {/* prevNodes: {prevNodes.length}{JSON.stringify(prevNodes)} */}
          {getDialogContent()}
        </LzDialog>
        {/* 画布新手引导弹窗 */}
        {
          // showGuidesDialog && <GuideDialog closeDialog={() => setShowGuidesDialog(false)}/>
        }
        {
          showNewTips &&
            <LzDialog
              visible={showNewTips}
              title=''
              style={{
                width: '500px',
                height: '300px',
                backgroundImage: `url(//img10.360buyimg.com/imgzone/jfs/t1/268547/15/18529/10415/67a992d9Fceafd87d/f3dbcc28aad7b816.png)`,
                backgroundRepeat: 'no-repeat',
                borderRadius: '14px',
                backgroundSize: 'contain',
                border: 'none'
              }}
              footer={false}
              onClose={()=>{setShowNewTips(false)}}
              closeMode={false}
            >
              <div style={{cursor: 'pointer', position: 'absolute', width: '10px', height: '10px', right: '25px', top: '25px'}} onClick={()=>{setShowNewTips(false)}}></div>
              <Checkbox checked={isCheck} onChange={(checked) => handleCheck(checked)} style={{position:'absolute',bottom: '10px', right: '57px',height: '30px',lineHeight: '30px'}}>
                <span style={{ color: 'rgba(0, 0, 0, 0.65)', marginLeft:"2px" }}>不再展示</span>
              </Checkbox>
            </LzDialog>
        }
        {/* 人群选择节点超过150提示弹窗 */}
        {
          crowdNodeNumDialog && <CrowdNumDialog flag={crowdNodeNumDialog} cancelHandel={()=>{
            setCrowdNodeNumDialog(false)
          }}/>
        }
        {/* 人群分析节点超过10提示弹窗 */}
        {
          crowdEffectNodeNumDialog && <CrowdEffectNumDialog flag={crowdEffectNodeNumDialog} cancelHandel={()=>{
            setCrowdEffectNodeNumDialog(false)
          }}/>
        }
        {
          deleteWinShow && <ConfirmDialog
            type="WARN"
            title="提示"
            promptInfo={deletePrompInfo}
            flag={deleteWinShow}
            confirmHandel={() => { deleteFocusItems(); setDeleteWinShow(false)}}
            cancelHandel={() => setDeleteWinShow(false)}
          />
        }
        <Loading visible={false} fullScreen></Loading>
      </div>
    </ActivityContext.Provider>
  );
};
